import React, { useEffect, useState } from "react"

import PropTypes from "prop-types"

import "./index.less"
import { MEASUREMENT_WIDGET_TYPE, TYPE_SURVEY } from "../../../utils/constants"
import WidgetResponseRateReport from "./components/WidgetResponseRateReport"
import WidgetListOutcomes from "./components/WidgetListOutcomes"
import WidgetChartEnps from "./components/WidgetChartEnps"
import WidgetListDimensions from "./components/WidgetListDimensions"
import {
  isAmbassadorOrLeaderActive,
  isLeaderActive,
} from "../../../utils/storage"

export function SummaryWidgets(props) {
  const [typeMeasureWidget, setTypeMeasureWidget] = useState(null)

  useEffect(() => {
    const { measureGeneral = {} } = props
    switch (measureGeneral.is_engagement) {
      case true:
        if (measureGeneral.has_enps) {
          if (measureGeneral.is_enps_engagement) {
            setTypeMeasureWidget(MEASUREMENT_WIDGET_TYPE.enpsAndEngagement)
          } else {
            setTypeMeasureWidget(MEASUREMENT_WIDGET_TYPE.onlyEnps)
          }
        } else {
          setTypeMeasureWidget(MEASUREMENT_WIDGET_TYPE.onlyEngagement)
        }
        break

      case false:
        setTypeMeasureWidget(MEASUREMENT_WIDGET_TYPE.leadershipOrClimate)
        break
    }
  }, [props.idMeasure])

  const renderWidgetResumeEnps = (typeMeasureWidget) => {
    const {
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props

    if (
      ![
        MEASUREMENT_WIDGET_TYPE.enpsAndEngagement,
        MEASUREMENT_WIDGET_TYPE.onlyEnps,
        MEASUREMENT_WIDGET_TYPE.leadershipOrClimate,
      ].includes(typeMeasureWidget)
    ) {
      return null
    }

    if (!measureGeneral.has_enps) {
      return null
    }

    return (
        <WidgetChartEnps
          idMeasure={idMeasure}
          measureGeneral={measureGeneral}
          idDivisionSelected={idDivisionSelected}
          idDivisionParent={idDivisionParent}
          selectedSegment={selectedSegment}
        />
    )
  }

  const renderWidgetResumeOutcomes = () => {
    if (
      ![
        MEASUREMENT_WIDGET_TYPE.enpsAndEngagement,
        MEASUREMENT_WIDGET_TYPE.onlyEnps,
        MEASUREMENT_WIDGET_TYPE.onlyEngagement,
      ].includes(typeMeasureWidget)
    ) {
      return null
    }
    const {
      history,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props
    return (
      <div className="WidgetResumeOutcomes boxShadow">
        <WidgetListOutcomes
          showTitle
          history={history}
          measureGeneral={measureGeneral}
          idMeasure={idMeasure}
          idDivisionSelected={idDivisionSelected}
          idDivisionParent={idDivisionParent}
          selectedSegment={selectedSegment}
        />
      </div>
    )
  }

  const renderWidgetResponseRateReport = () => {
    const {
      measureTotal,
      measureGeneral,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
      hasSegment,
    } = props
    return (
      <WidgetResponseRateReport
        measureData={measureTotal}
        measureGeneral={measureGeneral}
        idMeasure={idMeasure}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
        hasSegment={hasSegment}
      />
    )
  }

  const renderWidgetListDimensions = (typeMeasureWidget) => {
    if (typeMeasureWidget !== MEASUREMENT_WIDGET_TYPE.leadershipOrClimate) {
      return null
    }
    const {
      measureGeneral,
      idMeasure,
      idDivisionSelected,
      idDivisionParent,
      selectedSegment,
      hasSegment,
    } = props
    if (
      measureGeneral.segments.length > 1 &&
      (selectedSegment === 0 || selectedSegment === null) &&
      !isAmbassadorOrLeaderActive()
    ) {
      return null
    }

    return (
      <WidgetListDimensions
        measureGeneral={measureGeneral}
        idMeasure={idMeasure}
        idDivisionSelected={idDivisionSelected}
        idDivisionParent={idDivisionParent}
        selectedSegment={selectedSegment}
      />
    )
  }

  return (
    <div className="SummaryWidgets">
      {renderWidgetResumeEnps(typeMeasureWidget)}
      {renderWidgetResumeOutcomes(typeMeasureWidget)}
      {renderWidgetListDimensions(typeMeasureWidget)}
      {renderWidgetResponseRateReport()}
    </div>
  )
}

SummaryWidgets.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  history: PropTypes.object,
  measureTotal: PropTypes.object,
  measureEngagement: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  selectedSegment: PropTypes.number,
}

export default SummaryWidgets
